import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import App, { preloadScreensFor } from './App';
import mainCssReady from './routing/mainCssReady';

// Most screens are downloaded on demand (see routing/lazyPage.js). Fetch the one for
// this address before the first render, so the visitor goes straight from the page's
// own served copy to the real page, never through a blank loading state. The wait is
// capped: on a very slow connection the app renders anyway and shows its loading
// state until the screen arrives.
const PRELOAD_WAIT_MS = 4000;

const render = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

Promise.all([
  Promise.race([
    // Inside .then, and caught, so that even an unexpected error here still ends in
    // render() once the stylesheet is in.
    Promise.resolve().then(() => preloadScreensFor(window.location.pathname)).catch(() => {}),
    new Promise(resolve => setTimeout(resolve, PRELOAD_WAIT_MS)),
  ]),
  // The stylesheet no longer blocks the first paint (scripts/prerender.mjs), so wait
  // for it here: the real page is never drawn unstyled. Deliberately outside the 4 s
  // cap above: a blocking stylesheet used to hold this script back until it arrived,
  // so this keeps that guarantee. mainCssReady never rejects, resolves on a failed
  // load too (even one before this script ran), and has its own 10 s limit, so the
  // app always renders.
  mainCssReady(),
]).then(render, render);
